import React from 'react'
import {PageSection} from "../../../components/PageSection";
import ngage from "../../../services/ngage";
import {useNotifications} from "../../../context/NotificationContext";
import {ConfirmCodeData, ConfirmCodeForm} from "../Forms/ConfirmCodeForm";
import {useAuth} from "../../../context/AuthContext";
import {invalidate} from "../../../services/query-client";
import {useMutation} from "react-query";

// Types ----

type TwoFactorAuthConfirmCodeProps = {
  onBack: () => void;
  onContinue: () => void;
}

// Component ----

function TwoFactorAuthConfirmCode({onBack, onContinue}: TwoFactorAuthConfirmCodeProps) {
  const {notify} = useNotifications();
  const auth = useAuth();

  const {mutateAsync: confirmCode} = useMutation((code: string) => ngage.auth.twoFactorConfirmCode(code), {
    onSuccess: async () => {
      await invalidate(['users', {id: auth.user?.id ?? 0}], { refetchInactive: true });
      onContinue();
    },
    onError: () => notify("error", "Code verification", "The code you entered is incorrect. Please try again.")
  });

  return (
    <PageSection
      title='Enter your code'
    >
      <ConfirmCodeForm onCancel={onBack} onSubmit={values => confirmCode(values.code)} />
    </PageSection>
  );
}

export {TwoFactorAuthConfirmCode};